
import HomeCertificate from '../Home/HomeCertificate'
export default {
  components: {
    HomeCertificate
  },
  data () {
    return {
      data: [
        {
          id: 1,
          title: 'Vision',
          info: 'Our aim is to provide our customers with consistent quality that exceeds their expectations. At Advance Fiber we have great team of highly qualified Production and Quality Assurance personnel who control and check production. Our customers products are continually tested to the standards of the state of California, Europe, Japan and Australia / New Zealand.',
          img: 'about-card-01'
        },
        {
          id: 2,
          title: 'Mission',
          info: 'We want to sustain our business and nurture the environment, not destroy it, so that we can continue to serve our communities. Our model for sustainability includes responsible use of renewable resources, recycling our waste, high quality production, hard work and integrity.',
          img: 'about-card-02'
        },
        {
          id: 3,
          title: 'Capabilities',
          info: 'Advance Fiber is part of the Metroply Group, which has experience in producing MDF since 1994. Our latest production line in Kanchanaburi is state of the art, with our own know-how and expertise, combined with imported production equipment from Europe.Our experienced team are driven to provide our customers with consistent performance in terms of quality and service.',
          img: 'about-card-03'
        },
        {
          id: 4,
          title: 'Sustainability',
          info: "Sustainability is a key driver in our company's core values. We sustain and preserve the environment through the efficient use of renewable raw materials; the use of plantation rubber trees that has reached the end of its productive life.",
          infoSecond: "We understand that there is a growing demand for environmentally sustainable buildings in both structure and furniture and fittings. We aim to work with designers who need to consider and specify the source of materials, the impact of using such materials and the disposal of these materials.",
          infoThird: "Advance Fibre is proud to have met the rigorous standards set by the Forest Stewardship Council whose mission is to promote environmentally sound, socially beneficial and economically prosperous management of the world's forests. With this certification can now offer our customers and partners products that are FSC certified.",
          infoFourth: "The waste generated at our factories is used to generate energy for use in the production process. We have invested in the best available equipment so as to meet stringent environmental regulation making the who process environmentally friendly.",
          infoFifth: "A key to sustainability is maintaining excellent relationships with all our stakeholders including our customers, shareholders, suppliers, authorities and the community. We are guided by our core values of honesty and respect",
          img: false
        }
      ]
    }
  }
}
